"use client";

import { useTranslation } from "react-i18next";
import { forwardRef } from "react";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface CalendarCurrentTimeIndicatorProps {
  currentTime: Date;
  hourHeight: number;
}

export const CalendarCurrentTimeIndicator = forwardRef<
  HTMLDivElement,
  CalendarCurrentTimeIndicatorProps
>(({ currentTime, hourHeight }, ref) => {
  const { t, i18n } = useTranslation("common");

  return (
    <div className={"relative h-full w-full"}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              ref={ref}
              className="absolute right-0 z-25 flex h-1 w-full cursor-pointer items-center rounded-xl bg-pink-900"
              style={{
                top: `${(currentTime.getMinutes() / 60) * hourHeight}px`,
              }}
            >
              <span className={"h-2 w-2 rounded-full bg-pink-900"} />
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>
              {t("calendar.currentTime")}{" "}
              {currentTime.toLocaleTimeString(i18n.language, {
                hour: "numeric",
                minute: "2-digit",
              })}
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
});

CalendarCurrentTimeIndicator.displayName = "CalendarCurrentTimeIndicator";
